import { render, staticRenderFns } from "./XDevTableSearch.vue?vue&type=template&id=42bb149c&scoped=true"
import script from "./XDevTableSearch.vue?vue&type=script&lang=js"
export * from "./XDevTableSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb149c",
  null
  
)

export default component.exports